import { z } from 'zod';
import { ProdutoLocalEstoqueSchema } from '@/features/produto-local-estoque/types/ProdutoLocalEstoque';

export const EstoqueMovimentacaoResumoSchema = ProdutoLocalEstoqueSchema.pick({
    est_descricao: true,
    est_permite_movimentacao_manual: true,
    est_permite_transferencia: true,
    est_permite_venda: true,
    est_status: true,
});

export const ProdutoEstoqueSchema = z.object({
    estoque: EstoqueMovimentacaoResumoSchema.nullable(),
    pre_empresa_idpk: z.int(),
    pre_estoque_atual: z.number(),
    pre_estoque_disponivel: z.number(),
    pre_estoque_idpk: z.int().nullable(),
    pre_estoque_inicial: z.number(),
    pre_estoque_reservado: z.number(),
    pre_idpk: z.int(),
    pre_localizacao: z.string().nullable(),
    pre_padrao: z.enum(['S', 'N']),
    pre_produto_idpk: z.int(),
    pre_ultima_alteracao: z.string().nullable(),
    pre_ultima_entrada: z.string().nullable(),
    pre_ultima_saida: z.string().nullable(),
});

export type ProdutoEstoque = z.infer<typeof ProdutoEstoqueSchema>;
